import type { EngineRegistry, ExperienceActionType } from '../types/experienceEngine'
import Ajv from 'ajv'
import schema from '../generated/EngineRegistry.schema'

const SUPPORTED_SCHEMA_VERSION = 1

let registryPromise: Promise<EngineRegistry> | null = null

const validator = new Ajv({ allErrors: true, strict: true, strictRequired: false }).compile(schema)

export const validateEngineRegistry = (value: unknown): EngineRegistry => {
  if (!validator(value)) {
    const details = validator.errors?.map((entry) => `${entry.instancePath || '/'} ${entry.message}`).join('; ')
    throw new Error(`Engine registry schema validation failed: ${details}`)
  }
  if ((value as EngineRegistry).schemaVersion !== SUPPORTED_SCHEMA_VERSION) throw new Error('Unsupported Engine registry schema version.')
  return value as unknown as EngineRegistry
}

export const loadEngineRegistry = async (force = false): Promise<EngineRegistry> => {
  if (!force && registryPromise) return registryPromise
  registryPromise = (async () => {
    try {
      const response = await fetch('/EngineRegistry.json', { cache: force ? 'reload' : 'default' })
      if (!response.ok) throw new Error(`Registry request failed with ${response.status}.`)
      return validateEngineRegistry(await response.json())
    } catch (error) {
      registryPromise = null
      throw error
    }
  })()
  return registryPromise
}

export const isRegisteredAction = (
  registry: EngineRegistry,
  actionType: string,
): actionType is ExperienceActionType => actionType in registry.actions

export const clearEngineRegistryCacheForTests = () => {
  registryPromise = null
}
